module.exports = __webpack_public_path__ + "img/3_user.eb6d7ca4.svg";